module.exports = __webpack_public_path__ + "static/media/app-store@2x.ca0aa91f.png";